import { Translation } from 'types/Translation'

interface KnowledgeBaseEntity {
  id: number
  name: string
  nameTranslations?: Translation[]
  parent?: KnowledgeBaseEntity
}

const getKnowledgeBaseBreadcrumbsList = (e: KnowledgeBaseEntity, arr: KnowledgeBaseEntity[] = [])
: KnowledgeBaseEntity[] => (
  !e.parent ? [e] : [...getKnowledgeBaseBreadcrumbsList(e.parent, arr), e]
)

export { getKnowledgeBaseBreadcrumbsList }
export type { KnowledgeBaseEntity }
